import styled, { css } from 'styled-components';
import { SectionText } from 'styles/Typography.styled';
import { mediaQueries } from 'shared/breakpoints';

export const BoxWithText = styled.div(
    ({ theme: { colors } }) =>
        css`
            background-color: ${colors.primaryBlue500};
            display: flex;
            margin-bottom: 104px;
            padding: 32px;
            width: 100%;

            ${mediaQueries.sm} {
                background-color: ${colors.primaryBlue500};
                margin-bottom: 0;
                margin-top: 16px;
            }
        `,
);

export const Text = styled(SectionText)(
    ({ theme: { colors } }) =>
        css`
            color: ${colors.white};
            margin-left: 16px;
        `,
);
